import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

export type StatusTone = 'pos' | 'warn' | 'neg' | 'neutral' | 'info';

const pillVariants = cva(
  'inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full font-bold',
  {
    variants: {
      tone: {
        pos: 'bg-pos-soft text-pos',
        warn: 'bg-warn-soft text-warn',
        neg: 'bg-neg-soft text-neg',
        neutral: 'bg-muted text-text',
        info: 'bg-accent/20 text-accent-text',
      },
      size: {
        md: 'h-[26px] px-2.5 text-xs',
        sm: 'h-6 px-[9px] text-xs',
      },
    },
    defaultVariants: { tone: 'neutral', size: 'md' },
  },
);

export interface StatusPillProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: StatusTone;
  size?: 'md' | 'sm';
  /** Точка-маркер перед текстом (как в списке пользователей). */
  dot?: boolean;
  /** Иконка вместо точки (lucide, 12px). */
  icon?: React.ReactNode;
  /** Текст статуса — обязателен: цвет никогда не единственный носитель смысла. */
  children: React.ReactNode;
}

/** Статус-«таблетка» по макетам: мягкий фон тона + текст тона. */
export function StatusPill({ tone, size, dot, icon, className, children, ...props }: StatusPillProps) {
  return (
    <span className={cn(pillVariants({ tone, size }), className)} {...props}>
      {icon ?? (dot && <span aria-hidden className="size-1.5 rounded-full bg-current" />)}
      {children}
    </span>
  );
}
